import { useIcon } from '../../../hooks/useIcon';
import { Box } from '../../Box/Box';
import type { IconProps } from '../types';
import { IconPadlockUnlockedSvg } from './IconPadlockUnlockedSvg';

export const IconPadlockUnlocked: React.FC<IconProps> = (props) => {
  const iconProps = useIcon(props);
  return <Box component={IconPadlockUnlockedSvg} {...iconProps} />;
};
